import { useEffect, useRef, useState } from "react";
import { Eraser, PenLine } from "lucide-react";

export const SignaturePad = ({ value, onChange, label, testid }) => {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const [hasInk, setHasInk] = useState(Boolean(value));

  useEffect(() => {
    const canvas = canvasRef.current;
    const ratio = window.devicePixelRatio || 1;
    const rect = canvas.getBoundingClientRect();
    canvas.width = rect.width * ratio;
    canvas.height = rect.height * ratio;
    const ctx = canvas.getContext("2d");
    ctx.scale(ratio, ratio);
    ctx.lineWidth = 2.2;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.strokeStyle = "#0A0B0E";
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, rect.width, rect.height);
  }, []);

  const pos = (e) => {
    const rect = canvasRef.current.getBoundingClientRect();
    const point = e.touches ? e.touches[0] : e;
    return { x: point.clientX - rect.left, y: point.clientY - rect.top };
  };

  const start = (e) => {
    e.preventDefault();
    drawing.current = true;
    const ctx = canvasRef.current.getContext("2d");
    const { x, y } = pos(e);
    ctx.beginPath();
    ctx.moveTo(x, y);
  };

  const move = (e) => {
    if (!drawing.current) return;
    e.preventDefault();
    const ctx = canvasRef.current.getContext("2d");
    const { x, y } = pos(e);
    ctx.lineTo(x, y);
    ctx.stroke();
    setHasInk(true);
  };

  const end = () => {
    if (!drawing.current) return;
    drawing.current = false;
    onChange(canvasRef.current.toDataURL("image/png"));
  };

  const clear = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const rect = canvas.getBoundingClientRect();
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, rect.width, rect.height);
    setHasInk(false);
    onChange("");
  };

  return (
    <div data-testid={testid}>
      <div className="mb-2 flex items-center justify-between">
        <span className="font-mono text-[11px] font-bold uppercase tracking-[0.2em] text-neutral-400">
          {label}
        </span>
        <button
          type="button"
          data-testid={`${testid}-clear`}
          onClick={clear}
          className="flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.2em] text-neutral-500 transition-colors hover:text-flame"
        >
          <Eraser className="h-3 w-3" /> Șterge
        </button>
      </div>
      <canvas
        ref={canvasRef}
        data-testid={`${testid}-canvas`}
        onMouseDown={start}
        onMouseMove={move}
        onMouseUp={end}
        onMouseLeave={end}
        onTouchStart={start}
        onTouchMove={move}
        onTouchEnd={end}
        className="h-36 w-full cursor-crosshair touch-none rounded-xl border border-white/15 bg-white"
      />
      <p className="mt-2 flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.18em] text-neutral-500">
        <PenLine className="h-3 w-3 text-neon" />
        {hasInk ? "Semnătură aplicată" : "Semnează cu mouse-ul sau cu degetul"}
      </p>
    </div>
  );
};

export default SignaturePad;
